<template>
    <div>
        <div v-if="!ready">
            <fe-spinner class="spinner"/>
        </div>
        <highcharts v-else 
            :options="charts[0].config" 
            class="fe-chart" 
            ref="launchpad-incident-range-chart"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { incidentRangePatterns } from "@/components/charts/chartFormats/patterns/seriesPatterns"
export default {
    name: 'IncidentsRangeChart',
    data() {
        return {
            raw: null,
            charts: [],
            detailedColors: ['#19ADAB', '#FFEEAA', '#FFBD00', '#FF675D'],
            ready: false,
            totalStudents: 0,
        }
    },
    computed: {
        ...mapState('global', ['currentYear', 'defaultSchool']),
    },
    mounted() {
        this.loadData()
    },
    methods: {
        chartConfig() {
            let me = this
            return {
                chart: {
                    type: 'column',
                    stacked: true,
                    height: 300,
                },
                title: {
                    text: "Incident Ranges - This School Year",
                    style: {
                        fontWeight: '500',
                        color: '#050F2D',
                        fontSize: '14px'
                    }
                },
                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    },
                    labels: {
                        enabled: false
                    },
                    gridLineWidth: 0,
                    lineWidth: 0,
                    minorGridLineWidth: 0,
                    lineColor: 'transparent',
                    minorTickLength: 0,
                    tickLength: 0
                },
                yAxis: {
                    endOnTick: false,
                    labels: {
                        enabled: false,
                    },
                    title: false,
                    gridLineWidth: 0
                },
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        stacking: 'normal',
                        point: {
                            events: {
                                click(e) {
                                    //me.handleClick(e)
                                }
                            }
                        }
                    },
                    column: {
                        centerInCategory: me.$vuetify.breakpoint.name === 'sm' ? false : true
                    }
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    labelFormatter() {
                        let incident = this.name === '1' ? 'Incident' : 'Incidents'
                        let percent = this.yData[0] / me.totalStudents * 100
                        return `<div><div style="font-weight: 600">` +
                            `${this.name} ${incident}</div>` + 
                            `<div style="color:#495B8F;font-size:12px;font-weight:200;margin-top:10px;">(${parseFloat(percent).toFixed(2)}% of students)</div><div>`
                    },
                    itemMarginTop: 20,
                    margin: 0,
                    symbolRadius: 0,
                    symbolHeight: 16,
                    useHTML: true,
                    itemStyle: {
                        lineHeight: "10px"
                    },
                    x: me.$vuetify.breakpoint.name === 'md' ? 0 
                        : me.$vuetify.breakpoint.name === 'lg' ? -50 
                        : -70,
                    y: 15
                },
                tooltip: {
                    useHTML: true,
                    pointFormatter() {
                        let circle = this.series.legendSymbol.element.outerHTML.replace('<rect', '<circle cx="5" cy="5" r="5"').replace('</rect', '</circle')
                        let legendSymbol = "<svg height='10' width='10'>" + circle + "</svg>"
                        let incident = this.name === '1' ? 'Incident' : 'Incidents'
                        let percent = this.y / me.totalStudents * 100
                        return `<div class="incident-range-chart-series-tooltip">Students with ${this.series.name} ${incident}</div>` +
                         legendSymbol + ` <span class="incident-range-chart-series-tooltip">${parseFloat(percent).toFixed(2)}%</span> (${this.y.toLocaleString()} of ${me.totalStudents.toLocaleString()} students)`
                    },
                    headerFormat: ''
                },
                credits: {
                    enabled: false
                },
                series: []
            }
        },
        loadData() {
            const primaryOnly = window.localStorage.getItem('ec-incidents-primary-only')
            const showPrimaryOnly = primaryOnly !== null ? primaryOnly : '1'
            let p = {
                property: 'big5',
                school_year_id: this.currentYear.id,
                include_secondary_behaviors_responses: showPrimaryOnly === '1' ? 0 : 1 ,
                chart_types: 'detailed_pyramid',
                school_id: this.defaultSchool?.id
            }

            this.$modelGet('incidentRangeChart', p)
                .then(response => {
                    this.raw = response
                    this.buildCharts()
                })
        },
        buildCharts() {
            if (!this.raw) return
            this.charts = []
            let cfg = this.raw 
            let chartConfig = this.chartConfig()
            //build the series
            chartConfig.series = cfg.score_fields.map((range,i)=> {
                return { name: range, data: [], color: incidentRangePatterns[i], maxPointWidth: 120 }
            })

            // build the categories
            cfg.data.forEach((data,i)=>{
                if (chartConfig.xAxis.categories.indexOf(data[cfg.key] == -1)) chartConfig.xAxis.categories.push(data[cfg.key])
                chartConfig.series[i].data = [data.student_count]
            })

            this.charts.push({
                config: chartConfig
            })

            this.totalStudents = cfg.data[0].total_students

            this.ready = true
        }
    }
}
</script>

<style lang="scss" scoped>
.fe-chart {
    ::v-deep * {
        font-family: 'HyperlegibleSans-Regular', Hyperlegible Sans, 'Roboto', sans-serif !important;
    }
    ::v-deep .highcharts-br {
        margin: 30px;
    }
}
.spinner {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    line-height: 250px !important;
    z-index: 1000;
}
</style>

<style lang="scss">
.incident-range-chart-series-tooltip {
    font-weight: 600;
}
</style>
